module.exports = __webpack_public_path__ + "img/swansea-city-afc.2089a68c.png";